var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c("span", [_vm._v("群培训管理 >")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.groupName))])
      ]),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "top-button", attrs: { href: "javascript:;" } },
        [
          _c("el-button", { attrs: { type: "primary" } }, [
            _vm._v("群考核名单")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("el-tooltip", { attrs: { placement: "right", effect: "light" } }, [
        _c(
          "div",
          {
            staticClass: "tip-con",
            attrs: { slot: "content" },
            slot: "content"
          },
          [_c("p", [_vm._v("1、群考核名单是指没有通过岗前培训的名单")])]
        ),
        _vm._v(" "),
        _c("a", { staticClass: "tip-box" }, [_vm._v("？")])
      ]),
      _vm._v(" "),
      _c("tjkautocomplete", { on: { callBack: _vm.updateTjkId } }),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticStyle: { "margin-left": "10px" },
          attrs: { type: "danger" },
          on: {
            click: function($event) {
              return _vm.getList("tjk")
            }
          }
        },
        [_vm._v("查询淘金客")]
      ),
      _vm._v(" "),
      _c("el-input", {
        staticStyle: {
          width: "400px",
          "margin-left": "10px",
          "margin-bottom": "5px"
        },
        attrs: {
          type: "textarea",
          placeholder: "输入淘金号，用英文逗号隔开，例如940732001,949329488",
          autosize: { minRows: 2, maxRows: 3 }
        },
        model: {
          value: _vm.tjkNumbers,
          callback: function($$v) {
            _vm.tjkNumbers = $$v
          },
          expression: "tjkNumbers"
        }
      }),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticStyle: { "margin-left": "10px" },
          attrs: { type: "danger" },
          on: {
            click: function($event) {
              return _vm.getList("tjkNumbers")
            }
          }
        },
        [_vm._v("批量查询")]
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "tab" },
        _vm._l(_vm.examiningList, function(t, key) {
          return _c(
            "li",
            { class: { active: t.isCurrent } },
            [
              t.isCurrent
                ? [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/tjkStudy/voiceExam?id=" +
                            t.examineRecordId +
                            "&groupId=" +
                            _vm.groupId +
                            "&groupName=" +
                            _vm.groupName,
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(t.codeName) +
                            "  剩余考核人：" +
                            _vm._s(t.waitNum)
                        )
                      ]
                    )
                  ]
                : [
                    _vm._v(
                      "\n        " +
                        _vm._s(t.codeName) +
                        "  剩余考核人：" +
                        _vm._s(t.waitNum) +
                        "\n      "
                    )
                  ]
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      !_vm.success
        ? _c("p", { staticClass: "tj-shift-notice" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : [
            !_vm.list.length
              ? _c(
                  "p",
                  {
                    staticClass: "tj-shift-notice",
                    staticStyle: { "padding-top": "45px" }
                  },
                  [_vm._v("暂无记录！")]
                )
              : [
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        border: "",
                        data: _vm.list,
                        height:
                          _vm.type == "Voice"
                            ? _vm.tableHeight
                            : _vm.onlineTableHeight,
                        "tooltip-effect": "dark"
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", align: "center" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realName",
                          label: "考核人员",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tjkNumber",
                          label: "淘金号",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "是否通过", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "请选择" },
                                    model: {
                                      value: scope.row.passState,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "passState", $$v)
                                      },
                                      expression: "scope.row.passState"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      key: "Passed",
                                      attrs: { label: "通过", value: "Passed" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "Failed",
                                      attrs: {
                                        label: "未通过",
                                        value: "Failed"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "Abandoned",
                                      attrs: {
                                        label: "标记不参培",
                                        value: "Abandoned"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "Retrial",
                                      attrs: {
                                        label: "建议复训",
                                        value: "Retrial"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "AbandonInTrain",
                                      attrs: {
                                        label: "培训老师同意放弃",
                                        value: "AbandonInTrain"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "score",
                          label: "综合得分",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "只能填写数字",
                                    clearable: ""
                                  },
                                  model: {
                                    value: scope.row.score,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "score", $$v)
                                    },
                                    expression: "scope.row.score"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "remark",
                          label: "备注",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    autosize: "",
                                    placeholder: "不能超过200字",
                                    clearable: ""
                                  },
                                  model: {
                                    value: scope.row.remark,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "remark", $$v)
                                    },
                                    expression: "scope.row.remark"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tj-margin-top-xl" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: {
                            click: function($event) {
                              return _vm.toggleSelection("Passed")
                            }
                          }
                        },
                        [_vm._v("标记通过")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "info" },
                          on: {
                            click: function($event) {
                              return _vm.toggleSelection("Failed")
                            }
                          }
                        },
                        [_vm._v("标记不通过")]
                      ),
                      _vm._v(" "),
                      _vm.type == "Voice"
                        ? [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "warning" },
                                on: { click: _vm.checkGroup }
                              },
                              [_vm._v("群考核")]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type == "Online"
                        ? [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.saveOnline }
                              },
                              [_vm._v("保存打分")]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type == "Voice"
                        ? [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.saveVoice }
                              },
                              [_vm._v("保存打分")]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: { click: _vm.releaseGroup }
                        },
                        [_vm._v("发布成绩")]
                      )
                    ],
                    2
                  )
                ]
          ],
      _vm._v(" "),
      _c("Modal", { ref: "check" }, [
        _c("div", { staticClass: "tj-table tj-fill tj-padding-right-xl" }, [
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right" },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 外呼电话：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.check.callOutPhone,
                    callback: function($$v) {
                      _vm.$set(_vm.check, "callOutPhone", $$v)
                    },
                    expression: "check.callOutPhone"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right", staticStyle: { width: "200px" } },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 平均外呼时长（分钟）：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.check.avgDuration,
                    callback: function($$v) {
                      _vm.$set(_vm.check, "avgDuration", $$v)
                    },
                    expression: "check.avgDuration"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right", staticStyle: { width: "200px" } },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 考核代号：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.check.codeName,
                    callback: function($$v) {
                      _vm.$set(_vm.check, "codeName", $$v)
                    },
                    expression: "check.codeName"
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("Modal", { ref: "release" }, [
        _c(
          "div",
          {
            staticClass: "tj-table tj-fill tj-padding-right-xl",
            staticStyle: { "border-bottom": "1px solid #f2f2f2" }
          },
          [
            _c("dl", [
              _c(
                "dt",
                {
                  staticClass: "tj-text-right",
                  staticStyle: { width: "200px" }
                },
                [
                  _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                  _vm._v(" 考核通过流转群：")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "dd",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.release.shopGroupId,
                        callback: function($$v) {
                          _vm.$set(_vm.release, "shopGroupId", $$v)
                        },
                        expression: "release.shopGroupId"
                      }
                    },
                    _vm._l(_vm.shopGroupList, function(g, key) {
                      return _c("el-option", {
                        key: g.groupId,
                        attrs: { label: g.name, value: g.groupId }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("dl", [
              _c(
                "dt",
                {
                  staticClass: "tj-text-right",
                  staticStyle: { width: "200px" }
                },
                [
                  _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                  _vm._v(" 考核未通过学员：")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "dd",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.release.failedState,
                        callback: function($$v) {
                          _vm.$set(_vm.release, "failedState", $$v)
                        },
                        expression: "release.failedState"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "Kicked",
                        attrs: { label: "踢出本群", value: "Kicked" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("dl", [
              _c(
                "dt",
                {
                  staticClass: "tj-text-right",
                  staticStyle: { width: "200px" }
                },
                [
                  _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                  _vm._v(" 放弃和培训中放弃的学员：")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "dd",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.release.abandonState,
                        callback: function($$v) {
                          _vm.$set(_vm.release, "abandonState", $$v)
                        },
                        expression: "release.abandonState"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "Kicked",
                        attrs: { label: "踢出本群", value: "Kicked" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("dl", [
              _c(
                "dt",
                {
                  staticClass: "tj-text-right",
                  staticStyle: { width: "200px" }
                },
                [
                  _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                  _vm._v(" 通过发送的消息：")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "dd",
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "恭喜你通过了本次考核。"
                    },
                    model: {
                      value: _vm.release.passedMsg,
                      callback: function($$v) {
                        _vm.$set(_vm.release, "passedMsg", $$v)
                      },
                      expression: "release.passedMsg"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("dl", [
              _c(
                "dt",
                {
                  staticClass: "tj-text-right",
                  staticStyle: { width: "200px" }
                },
                [
                  _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                  _vm._v(" 留在本群发送的消息：")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "dd",
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "考核成绩已发布。"
                    },
                    model: {
                      value: _vm.release.stayMsg,
                      callback: function($$v) {
                        _vm.$set(_vm.release, "stayMsg", $$v)
                      },
                      expression: "release.stayMsg"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("dl", [
              _c(
                "dt",
                {
                  staticClass: "tj-text-right",
                  staticStyle: { width: "200px" }
                },
                [
                  _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                  _vm._v(" 踢出本群发送的消息：")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "dd",
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "考核成绩已发布，很遗憾你没有通过本次考核。"
                    },
                    model: {
                      value: _vm.release.kickMsg,
                      callback: function($$v) {
                        _vm.$set(_vm.release, "kickMsg", $$v)
                      },
                      expression: "release.kickMsg"
                    }
                  })
                ],
                1
              )
            ])
          ]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a5db110", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a5db110","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/college/groupTrain.vue
// module id = 1162
// module chunks = 0